import { reactive, toRef } from "vue";
import { useCookie } from "@/plugins/cookie";
import { axiosYt } from "@/services/axios-yt";

const { getCookie } = useCookie();

const state = reactive({
  wasOpen: getCookie("bannerAppModal") === "true",
});

async function getQrCodeUrl() {
  const { data } = await axiosYt.get("/download-app/?get_qr_link=Y");
  return data.data.qrImage;
}

export function useBannerApp() {
  return {
    wasOpen: toRef(state, "wasOpen"),
    getQrCodeUrl,
  };
}
